import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your config (keep this private in production)
const firebaseConfig = {
  apiKey: "AIzaSyCcaoVIzjoQIwAJ_9m_zxBcjPcWBjuSmBk",
  authDomain: "sign-up-login-page-af63e.firebaseapp.com",
  projectId: "sign-up-login-page-af63e",
  storageBucket: "sign-up-login-page-af63e.appspot.com",
  messagingSenderId: "287209245759",
  appId: "1:287209245759:web:51b8f5b8a2059ec6277c8a",
  measurementId: "G-Y3LG7P2VWP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;